import React from 'react';
import { connect } from 'react-redux';
import ReactToPrint from 'react-to-print';

import S from 'constants/string.const';
import { withIsFromMobileApp } from 'hooks/useIsFromMobileApp.hook';
import { withGilt, withTranslation } from 'providers/GILT.provider';

import ComponentToPrint from 'reports/Common/ComponentToPring';
import ReportsMainLayoutContainer from 'reports/Common/ReportsMainLayout';
import CategoryRevenueTableContainer from 'reports/RevenueTables/CategoryRevenueTable';
import DiscountByStylist from 'reports/RevenueTables/DiscountByStylist';
import RevenueByServicesTable from 'reports/RevenueTables/RevenueByServicesTable';
import RevenueByStylistTableContainer from 'reports/RevenueTables/RevenueByStylistTable';

const ReportsProps = ['salesReport', 'salesDiscountsReport'];

class RevenueReports extends ReportsMainLayoutContainer {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      shownTables: 0,
    };
    this.componentRef = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.currentTable === 'Discounts') {
      window.scrollTo(0, 1100);
    }
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    const { uniqueVisitsReport, t, formatDate, isSalonInGB } = this.props;
    return (
      <div className="has-protipbox revenue">
        <div className="new-wraper">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
            </div>
          )}
          {this.props.salesReport.lastRequestResponse && (
            <div className="box revenue" style={{ marginBottom: '25px' }}>
              <div className="banner default full-width">
                <div style={{ width: '100%' }}>
                  <div className="cfix relative">
                    <span className="img-emoji-1" role="img" aria-labelledby="lamp">
                      {S.lamp}
                    </span>
                    <div className="text">
                      <strong>{t('businessReports.revenueReports.proTipTitle')}</strong>
                      <span>{t('businessReports.revenueReports.proTipDescription1.part1')}</span>
                      {S.space}
                      {isSalonInGB && (
                        <span>
                          {t('businessReports.revenueReports.proTipDescription1.part2')} {S.arrowUpR}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="cfix relative">
                    <span className="img-emoji-2" role="img" aria-labelledby="lamp">
                      {S.lamp}
                    </span>
                    <div className="text">
                      <strong>{t('businessReports.revenueReports.proTipTitle')}</strong>
                      {t('businessReports.revenueReports.proTipDescription2')}
                    </div>
                  </div>
                </div>
                {!this.props.isFromMobile && (
                  <div className="link">
                    <a href="https://help.getslick.com/en/articles/1651792-how-to-checkout-a-client" alt="Heed help" target="_blank" rel="noopener noreferrer">
                      {t('businessReports.revenueReports.needHelp')}
                    </a>
                    <ReactToPrint trigger={() => <button className="btn-print-pdf-reports">{t('businessReports.revenueReports.printPDF')}</button>} content={() => this.componentRef.current} />
                  </div>
                )}
              </div>
              <div className="title" style={{ marginTop: '18px' }}>{`${this.state.title}`}</div>
              <ComponentToPrint ref={this.componentRef} componentRef>
                <RevenueByStylistTableContainer
                  startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                  endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                  data={this.props.salesReport.lastRequestResponse.stylist_group.filter((s) => s.total_revenue !== 0)}
                  salonVatRate={this.props.salonVatRate}
                  visits={this.props.salesReport.lastRequestResponse.visits}
                  unique_client_visits={this.props.salesReport.lastRequestResponse.visits}
                />
                <CategoryRevenueTableContainer
                  startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                  endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                  dataCategory={this.props.salesReport.lastRequestResponse.category_group}
                  dataProducts={this.props.salesReport.lastRequestResponse.product_group}
                  stylists={this.props.salesReport.lastRequestResponse.stylist_group}
                  salonVatRate={this.props.salonVatRate}
                />
                <RevenueByServicesTable
                  startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                  endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                  salonVatRate={this.props.salonVatRate}
                />
                <DiscountByStylist
                  startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                  endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                  data={this.props.salesReport.lastRequestResponse.stylist_group}
                  discountReport={this.props.salesDiscountsReport}
                  salonVatRate={this.props.salonVatRate}
                />
              </ComponentToPrint>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId, stylistList },
    reports,
  } = state;
  const { salesReport, uniqueVisitsReport, globalDiscount, salesDiscountsReport, salonVatRate, currentTable, isFetching } = reports;
  return {
    salonId,
    stylistList,
    salesReport,
    uniqueVisitsReport,
    salonVatRate,
    salesDiscountsReport,
    currentTable,
    isFetching,
    globalDiscount: globalDiscount.discount,
  };
}

export default connect(mapStateToProps, {})(withIsFromMobileApp(withGilt(withTranslation()(RevenueReports))));
